import React from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Col,
  Row,
  Table,
  Label,
  Container,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import _ from "lodash";
import api from "../../api";
import FromNow from "../../components/Time/FromNow";
import SiteDropdownInput from "components/SiteDropdownInput";
import "./index.css";

const STATUS_FILTER = [
  { label: "All", value: "all" },
  //   { label: "Draft", value: "draft" },
  //   { label: "Approved", value: "approved" },
  //   { label: "Waiting for approval", value: "waiting_for_approval" },
  { label: "Đang xây dựng", value: "under-construction" },
  { label: "Đang hoạt động", value: "complete" },
  { label: "Đã đóng cửa", value: "closed" }
];

// The Roster component matches one of two different routes
// depending on the full pathname
export default class MarketInformationScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sites: [],
      siteCount: 0,
      pagesCount: 0,
      page: 0,
      limit: 15,
      isLoading: false,
      statusFilter: STATUS_FILTER[0],
      selectedStatus: STATUS_FILTER[2],
      selectedBrand: null,
      isShowModal: false,
      site: {
        external_status: STATUS_FILTER[2].value
      },
      brandList: [],
      brandCompetitorList: [],
      isShowCompetiorList: true,
      labelNames: []
    };
    this.searchLocation = _.debounce(this.searchLocation, 500);
    // this.getBrandByName = _.debounce(this.getBrandByName, 500);
    this.updateAttr = this.updateAttr.bind(this);
  }
  UNSAFE_componentWillMount() {
    this.getCurrentUser();
  }
  componentDidMount = () => {};
  getCurrentUser() {
    api.fetchAPI({
      method: "get",
      uri: `userme/me`,
      success: response => {
        if (response.result) {
          console.log(response.result);
          this.setState(
            {
              currentUser: response.result
            },
            // () => this.getSites(0)
            () => this.getBrandCompetitor(response.result.user_brand.brand_id)
          );
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: error => {
        console.error(error);
      }
    });
  }
  getBrandCompetitor(id) {
    const filterString = `(col:is_active,opr:eq,value:1),(col:brand,opr:rel_o_m,value:${id})`;
    api.fetchAPI({
      method: "get",
      uri: `brand_competitor/?q=(filters:!(${filterString}))`,
      success: response => {
        if (response.result) {
          const brandCompetitorList = response.result.map(item => {
            return {
              label: item.competitor.name,
              value: {
                id: item.competitor.id,
                name: item.competitor.name
              }
            };
          });
          this.setState(
            {
              brandCompetitorList,
              selectedBrand:
                brandCompetitorList.length > 0 ? brandCompetitorList[0] : null,
              searchBrandId:
                brandCompetitorList.length > 0
                  ? brandCompetitorList[0].value.id
                  : 0
            },
            () => this.getSites(0)
          );
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: error => {
        console.error(error);
      }
    });
  }
  getBrandByLocationType(locationType) {
    const filterString = `(col:is_active,opr:eq,value:1),(col:location_type,opr:rel_o_m,value:${locationType.id})`;
    api.fetchAPI({
      method: "get",
      uri: `brand_location_type/?q=(filters:!(${filterString}))`,
      success: response => {
        if (response.result) {
          const brandList = response.result.map(item => {
            return {
              label: item.brand.name,
              value: {
                id: item.brand.id,
                name: item.brand.name
              }
            };
          });
          this.setState({ brandList });
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: error => {
        console.error(error);
      }
    });
  }
  searchLocation() {
    this.getSites();
  }
  async getSites(pageNumber = 0) {
    await this.setState({ page: pageNumber });
    const {
      page,
      limit,
      statusFilter,
      currentUser,
      searchKeyword,
      searchName,
      searchLocationType,
      searchBrandId
    } = this.state;
    let siteFilterString = "(col:is_active,opr:eq,value:1)";
    if (statusFilter) {
      if (statusFilter.value && statusFilter.value !== "all") {
        siteFilterString =
          siteFilterString +
          `,(col:external_status,opr:eq,value:${statusFilter.value})`;
      }
    }
    // siteFilterString = siteFilterString + `,(col:brand,opr:rel_o_m,value:1043)`;
    siteFilterString =
      siteFilterString + `,(col:is_site_dev_location,opr:eq,value:0)`;
    if (searchLocationType) {
      siteFilterString =
        siteFilterString +
        `,(col:location_type,opr:rel_o_m,value:${searchLocationType.id})`;
    }
    // if (currentUser) {
    //   if (currentUser.user_brand) {
    //     console.log(currentUser.user_brand);
    //     siteFilterString =
    //       siteFilterString +
    //       `,(col:brand,opr:rel_o_m,value:${currentUser.user_brand.brand_id})`;
    //     if (!currentUser.user_brand.can_view_other_brand_site) {
    //       // siteFilterString = siteFilterString + `,(col:brand,opr:rel_o_m,value:${currentUser.user_brand.brand_id})`;
    //     }
    //   }
    // }
    if (searchKeyword) {
      const encodedSearchKeyword = searchKeyword;
      const searchByFields = [
        // 'name',
        "street_name"
        // 'address'
      ];
      searchByFields.map(searchByField => {
        siteFilterString =
          siteFilterString +
          `,(col:${searchByField},opr:ct,value:'${encodedSearchKeyword}')`;
      });
    }
    if (searchName) {
      const encodedSearchName = searchName;
        siteFilterString =
          siteFilterString +
          `,(col:name,opr:ct,value:'${encodedSearchName}')`;
    }
    if (searchBrandId) {
      siteFilterString =
        siteFilterString + `,(col:brand,opr:rel_o_m,value:'${searchBrandId}')`;
    }
    api.fetchAPI({
      method: "get",
      uri: `location/?q=(page:${page},page_size:${limit},order_columns:created_on,order_direction:desc,filters:!(${siteFilterString}))`,
      success: response => {
        this.setState({
          sites: response.result,
          siteCount: response.count,
          pagesCount: Math.floor(response.count / limit) + 1
        });
        this.setState({ isLoading: false });
      },
      error: error => {
        console.error(error);
        this.setState({ isLoading: false });
      }
    });
  }
  updateAttr(attribute, value) {
    const { site } = this.state;
    if (value == "") value = null;
    site[attribute] = value;

    this.setState({ site }, () => {
      if (attribute == "location_type") {
        this.getBrandByLocationType(value);
      }
    });
  }
  render() {
    const {
      sites,
      pagesCount,
      statusFilter,
      selectedStatus,
      selectedBrand,
      searchKeyword,
      searchName,
      isShowModal,
      site,
      labelNames,
      searchLocationType,
      brandList,
      isShowCompetiorList,
      brandCompetitorList,
      currentUser
    } = this.state;
    if (!sites) return null;
    return (
      <Container>
        <div className="page-container">
          <Row>
            <Col xs={12}>
              <h1>Thông tin thị trường</h1>
            </Col>
            <Col xs={12}>
              <Button
                color="success"
                onClick={() =>
                  this.setState({
                    isShowModal: true,
                    selectedBrand: null
                  })
                }
              >
                Create
              </Button>
            </Col>
          </Row>
          <br />
          <div></div>
          <FormGroup style={{ marginLeft: 20 }}>
            <FormGroup>
              <Label>
                <Input
                  type="radio"
                  checked={isShowCompetiorList}
                  onClick={value => {
                    this.setState(
                      {
                        isShowCompetiorList: true,
                        searchLocationType: null,
                        searchBrandId: null,
                        selectedBrand: null,
                        brandList: []
                      },
                      () =>
                        this.getBrandCompetitor(currentUser.user_brand.brand_id)
                    );
                  }}
                />{" "}
                Địa điểm của đối thủ
              </Label>
            </FormGroup>
            <FormGroup>
              <Label>
                <Input
                  type="radio"
                  checked={!isShowCompetiorList}
                  onClick={value => {
                    this.setState(
                      {
                        isShowCompetiorList: false,
                        searchLocationType: null,
                        searchBrandId: null,
                        selectedBrand: null,
                        brandCompetitorList: []
                      },
                      () => this.getSites(0)
                    );
                  }}
                />{" "}
                Tất cả địa điểm
              </Label>
            </FormGroup>
          </FormGroup>
          <Row className="site-listing__filters">
            {!isShowCompetiorList && (
              <Col xs={12} sm={6} md={4}>
                <SiteDropdownInput
                  apiUrl="location_type/"
                  callback={(attributeName, value) => {
                    console.log(value);
                    this.setState({ searchLocationType: value, selectedBrand: null, searchBrandId: null }, () => {
                      this.searchLocation();
                      this.getBrandByLocationType(value);
                    });
                  }}
                  site={site}
                  labels={{
                    location_type: "Mô hình kinh doanh"
                  }}
                  attributeName="location_type"
                />
              </Col>
            )}
            {isShowCompetiorList && (
              <Col xs={12} sm={6} md={4} style={{ paddingBottom: 16 }}>
                <Label>Chọn thương hiệu</Label>
                <Select
                  options={brandCompetitorList}
                  value={selectedBrand}
                  placeholder="Chọn thương hiệu"
                  onChange={selectedOption => {
                    this.setState(
                      {
                        searchBrandId: selectedOption.value.id,
                        selectedBrand: selectedOption
                      },
                      this.searchLocation
                    );
                  }}
                />
              </Col>
            )}
            <Col xs={12} sm={6} md={8}>
              {searchLocationType && (
                <div>
                  <Label>Chọn thương hiệu</Label>
                  <Select
                    options={brandList}
                    value={selectedBrand}
                    placeholder="Chọn thương hiệu"
                    onChange={selectedOption => {
                      this.setState(
                        {
                          searchBrandId: selectedOption.value.id,
                          selectedBrand: selectedOption
                        },
                        this.searchLocation
                      );
                    }}
                  />
                </div>
              )}
            </Col>
            <Col xs={12} sm={6} md={8}>
              <FormGroup>
                <Label>Search theo tên đường</Label>
                <Input
                  className="form-group"
                  // placeholder="Search theo tên đường..."
                  value={searchKeyword}
                  onChange={e =>
                    this.setState(
                      { searchKeyword: e.target.value },
                      this.searchLocation
                    )
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <FormGroup>
                <Label>Status</Label>
                <Select
                  options={STATUS_FILTER}
                  value={statusFilter}
                  onChange={selectedOption =>
                    this.setState(
                      { statusFilter: selectedOption, page: 0 },
                      this.getSites
                    )
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} sm={6} md={8}>
              <FormGroup>
                <Label>Search theo tên địa điểm</Label>
                <Input
                  className="form-group"
                  // placeholder="Search theo tên đường..."
                  value={searchName}
                  onChange={e =>
                    this.setState(
                      { searchName: e.target.value },
                      this.searchLocation
                    )
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              {pagesCount && pagesCount > 0 ? (
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={pagesCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  initialPage={0}
                  onPageChange={page => this.getSites(page.selected)}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              ) : null}
            </Col>
          </Row>
          <Table className="site-listing__tables">
            <thead>
              <tr>
                <th>Thương hiệu</th>
                <th>Địa chỉ</th>
                <th>Thành phố</th>
                <th>Tạo lúc</th>
                <th>Trạng thái</th>
              </tr>
            </thead>
            <tbody>
              {sites.map(site => (
                <tr key={site.id}>
                  <td>
                    {site && site.brand && site.brand.name
                      ? site.brand.name
                      : ""}
                  </td>
                  <td>
                    {site.brand && site.brand.brand_logo_image && (
                      <img
                        className="site-listing__brand-logo-img"
                        src={site.brand.brand_logo_image}
                        alt={site.brand}
                      />
                    )}
                    <Link to={`/market_information/${site.id}`}>
                      {site.address ? (
                        <span>{site.address === "" ? "Chưa có địa chỉ" : site.address}</span>
                      ) : (
                        <span>{site.full_address === "" ? "Chưa có địa chỉ" : site.full_address}</span>
                      )}
                    </Link>
                  </td>
                  <td>{site.city && site.city.name}</td>
                  <td>
                    <FromNow value={site.created_on} />
                  </td>
                  <td>
                    {site.external_status && (
                      <span
                        className={`site-status-label ${site.external_status}`}
                      >
                        {site.external_status}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="site-listing__cards">
            <Row>
              {sites.map(site => (
                <Col xs={12} key={site.id} className="site-listing__card">
                  <div className="site-listing__content">
                    <p>
                      {site.brand && site.brand.brand_logo_image && (
                        <img
                          className="site-listing__brand-logo-img"
                          src={site.brand.brand_logo_image}
                          alt={site.brand}
                        />
                      )}
                      <span
                        className={`site-status-label ${site.site_dev_status}`}
                      >
                        {site.site_dev_status}
                      </span>
                    </p>
                    <Link
                      to={`/market_information/${site.id}`}
                      className="site-listing__card-address"
                    >
                      {site.address ? (
                        <span>{site.address}</span>
                      ) : (
                        <span>{site.full_address}</span>
                      )}
                    </Link>
                    <p className="site-listing__card-since">
                      <span className="site-listing__card-creator">
                        {site.created_by.first_name} {site.created_by.last_name}
                      </span>
                      <FromNow value={site.created_on} />
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
        <div>
          <Modal
            centered={true}
            isOpen={isShowModal}
            toggle={() => {
              const { site } = this.state;
              delete site.brand;
              this.setState({ isShowModal: false, selectedBrand: null, site });
            }}
          >
            <ModalHeader style={{ alignSelf: "center" }}>
              Thông tin thị trường
            </ModalHeader>
            <ModalBody>
              <SiteDropdownInput
                apiUrl="location_type/"
                callback={this.updateAttr}
                labels={labelNames}
                placeholder="Chọn mô hình kinh doanh"
                site={site}
                attributeName="location_type"
              />
              {/* {site &&
                site.location_type &&
                BRAND_LIST[site.location_type.id] &&
                BRAND_LIST[site.location_type.id].length > 0 && (
                  <Select
                    options={BRAND_LIST[site.location_type.id]}
                    value={selectedBrand}
                    placeholder="Chọn thương hiệu"
                    onChange={selectedOption => {
                      const { site } = this.state;
                      site["brand"] = selectedOption.value;
                      this.setState({
                        site,
                        selectedBrand: selectedOption
                      });
                    }}
                  />
                )} */}
              {site && site.location_type && site.location_type.id && (
                <Select
                  options={brandList}
                  value={selectedBrand}
                  placeholder="Chọn thương hiệu"
                  onChange={selectedOption => {
                    const { site } = this.state;
                    site["brand"] = selectedOption.value;
                    this.setState({
                      site,
                      selectedBrand: selectedOption
                    });
                  }}
                />
              )}
              <br />
              <Select
                options={STATUS_FILTER.slice(1, STATUS_FILTER.length)}
                value={selectedStatus}
                onChange={selectedOption => {
                  const { site } = this.state;
                  site["external_status"] = selectedOption.value;
                  this.setState({
                    site,
                    selectedStatus: selectedOption
                  });
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                disabled={!(site.external_status && site.location_type)}
                tag={Link}
                to={{
                  pathname: `/market_information/create`,
                  state: { site }
                }}
                style={{ flex: 1 }}
                color="primary"
                onClick={() => {
                  console.log(site);
                  this.setState({ isShowModal: false });
                }}
              >
                Tạo phiếu thông tin
              </Button>{" "}
            </ModalFooter>
          </Modal>
        </div>
      </Container>
    );
  }
}

const BRAND_LIST = {
  "1": [
    {
      label: "The Coffee House",
      value: {
        id: 1,
        name: "The Coffee House"
      }
    },
    {
      label: "Highland Coffee",
      value: {
        id: 2,
        name: "Highland Coffee"
      }
    },
    {
      label: "GUTA",
      value: {
        id: 3,
        name: "GUTA"
      }
    },
    {
      label: "Cộng Cà Phê",
      value: {
        id: 4,
        name: "Cộng Cà Phê"
      }
    },
    {
      label: "AHA",
      value: {
        id: 5,
        name: "AHA"
      }
    },
    {
      label: "PASSIO",
      value: {
        id: 6,
        name: "PASSIO"
      }
    },
    {
      label: "Phuc Long",
      value: {
        id: 7,
        name: "Phuc Long"
      }
    },
    {
      label: "Starbucks",
      value: {
        id: 8,
        name: "Starbucks"
      }
    },
    {
      label: "Milano",
      value: {
        id: 9,
        name: "Milano"
      }
    },
    {
      label: "VIVA STAR",
      value: {
        id: 10,
        name: "VIVA STAR"
      }
    }
  ],
  "3": [
    {
      label: "AEON",
      value: {
        id: 1036,
        name: "AEON"
      }
    },
    {
      label: "Lotte Mart",
      value: {
        id: 1035,
        name: "Lotte Mart"
      }
    },
    {
      label: "Emart",
      value: {
        id: 1034,
        name: "Emart"
      }
    },
    {
      label: "Big C",
      value: {
        id: 1037,
        name: "Big C"
      }
    },
    {
      label: "Co.opXtra",
      value: {
        id: 1038,
        name: "Co.opXtra"
      }
    },
    {
      label: "Co.opmart",
      value: {
        id: 1039,
        name: "Co.opmart"
      }
    }
  ],
  "10": [
    {
      label: "GS25",
      value: {
        id: 1024,
        name: "GS25"
      }
    },
    {
      label: "B Mart",
      value: {
        id: 1025,
        name: "B Mart"
      }
    },
    {
      label: "VINMART",
      value: {
        id: 1026,
        name: "VINMART"
      }
    },
    {
      label: "7-Eleven",
      value: {
        id: 1027,
        name: "7-Eleven"
      }
    },
    {
      label: "Circle K",
      value: {
        id: 1028,
        name: "Circle K"
      }
    },
    {
      label: "MINISTOP",
      value: {
        id: 1029,
        name: "MINISTOP"
      }
    },
    {
      label: "FamilyMart",
      value: {
        id: 1030,
        name: "FamilyMart"
      }
    }
  ],
  "12": [
    {
      label: "VINMART",
      value: {
        id: 1026,
        name: "VINMART"
      }
    },
    {
      label: "Bách hóa Xanh",
      value: {
        id: 1043,
        name: "Bách hóa Xanh"
      }
    }
  ]
};
